import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { postData } from 'src/api/api-utilities'
import { useToastAlert } from 'src/stores/ToastContext'

const updateSessionStatus = async (params) => {
  const { data, sessionId } = params
  const response = await postData(`/my_evanta/event_one_on_one_meeting_survey/${sessionId}`, { ...data })
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response
}

const useUpdateP2PSessionEvalStatus = () => {
  const { eventId } = useParams()
  const { setAlert } = useToastAlert()
  const queryClient = useQueryClient()
  const { mutateAsync, mutate } = useMutation({
    mutationFn: updateSessionStatus,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [`sessions_${eventId}`] })
    },
    onError: (error) => {
      setAlert({
        status: error.code,
        title: 'Attention',
        message: error.info || error.text,
        forceLogout: false
      })
    }
  })

  return { mutateAsync, mutate }
}

export default useUpdateP2PSessionEvalStatus
